/* === SHŌ ITO signup attribution (2026-09-30) ===
   2026-10-05: 流入元の記録（window.siSignupAttribution）と Klaviyo への送信（window.siKlaviyoSubscribe）は
   snippets/si-signup.liquid に移した（両方のレイアウトの <head> で読み込む＝どのページでも同じ動き）。 */

/* SHŌ ITO Redesign v2.1 — interaction JS
 * - Sticky header scroll state
 * - Mobile overlay open/close
 * - Popup P1 (3s delay + animated entry + floating reopen tab) — B improvement
 * - Popup P5 (waitlist confirmation, fires on Klaviyo success) — H improvement, NEW
 * - Klaviyo waitlist subscribe (P5 fires on success)
 * - Reveal-on-scroll IntersectionObserver
 */

(function () {
  'use strict';
  // ---------- Cookie helpers ----------
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
    return match ? decodeURIComponent(match[3]) : null;
  }

  // ---------- Sticky header ----------
  function initHeader() {
    var header = document.querySelector('[data-v2-header]');
    if (!header) return;
    var onScroll = function () {
      if (window.scrollY > 64) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---------- Mobile overlay ----------
  function initMobileOverlay() {
    var burger = document.querySelector('[data-v2-hamburger]');
    var overlay = document.querySelector('[data-v2-mobile-overlay]');
    if (!burger || !overlay) return;
    var closeBtn = overlay.querySelector('[data-v2-overlay-close]');
    var open = function () {
      overlay.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      burger.setAttribute('aria-label', 'Close menu');
      document.body.style.overflow = 'hidden';
    };
    var close = function () {
      overlay.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', 'Open menu');
      document.body.style.overflow = '';
    };
    burger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
  }

  // ---------- Popup P1 (B improvement) ----------
  // 3s delay trigger + animated entry. Reopen tab is persistent until P5 fires
  // (i.e. until the visitor successfully joins the list).
  function initPopupP1() {
    var dialog = document.querySelector('[data-v2-popup="p1"]');
    var reopen = document.querySelector('[data-v2-popup-reopen]');
    if (!dialog) return;
    var cookieName = dialog.dataset.cookie || 'shoito_v2_p1';
    var days = parseInt(dialog.dataset.cookieDays, 10) || 30;
    var triggerMs = parseInt(dialog.dataset.triggerMs, 10) || 3000;
    var dismissed = !!getCookie(cookieName);

    var open = function () {
      try { dialog.showModal(); } catch (e) {
        dialog.setAttribute('open', 'open');
        dialog.style.display = 'block';
      }
      // Animate
      requestAnimationFrame(function () {
        dialog.classList.add('is-open');
      });
    };

    var close = function () {
      dialog.classList.remove('is-open');
      setTimeout(function () {
        try { dialog.close(); } catch (e) {
          dialog.removeAttribute('open'); dialog.style.display = 'none';
        }
      }, 260);
      setCookie(cookieName, 'shown', days);
      // After close, show the floating reopen tab — unless P5 has already fired (subscribe success)
      if (reopen && !getCookie('shoito_v2_p5_done')) {
        reopen.hidden = false;
        requestAnimationFrame(function () { reopen.classList.add('is-visible'); });
      }
    };

    var closeBtns = dialog.querySelectorAll('[data-v2-popup-close]');
    closeBtns.forEach(function (b) {
      b.addEventListener('click', close);
    });
    // Native ESC close — keep the cookie flow
    dialog.addEventListener('close', function () {
      // Only set cookie if user actively dismissed (we set it on close already; safe to set twice)
      setCookie(cookieName, 'shown', days);
      dialog.classList.remove('is-open');
      if (reopen && !getCookie('shoito_v2_p5_done')) {
        reopen.hidden = false;
        requestAnimationFrame(function () { reopen.classList.add('is-visible'); });
      }
    });

    // Reopen tab → reopen dialog
    if (reopen) {
      reopen.addEventListener('click', function () {
        reopen.classList.remove('is-visible');
        reopen.hidden = true;
        open();
      });
      // If user already dismissed earlier and now P5 hasn't fired, expose the reopen tab right away
      if (dismissed && !getCookie('shoito_v2_p5_done')) {
        reopen.hidden = false;
        requestAnimationFrame(function () { reopen.classList.add('is-visible'); });
      }
    }

    // First-time visitors: open after 3s
    if (!dismissed) {
      setTimeout(open, triggerMs);
    }
  }

  // ---------- Popup P5 (H improvement, NEW) ----------
  // Triggered manually by initWaitlistForms on Klaviyo success.
  function showPopupP5() {
    var dialog = document.querySelector('[data-v2-popup="p5"]');
    if (!dialog) return;
    // Hide the P1 reopen tab — visitor has signed up
    var reopen = document.querySelector('[data-v2-popup-reopen]');
    if (reopen) { reopen.classList.remove('is-visible'); reopen.hidden = true; }
    setCookie('shoito_v2_p5_done', '1', 365);
    try { dialog.showModal(); } catch (e) {
      dialog.setAttribute('open', 'open'); dialog.style.display = 'block';
    }
    requestAnimationFrame(function () { dialog.classList.add('is-open'); });

    var closeBtns = dialog.querySelectorAll('[data-v2-popup-close]');
    closeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        dialog.classList.remove('is-open');
        setTimeout(function () {
          try { dialog.close(); } catch (e) {
            dialog.removeAttribute('open'); dialog.style.display = 'none';
          }
        }, 260);
      }, { once: true });
    });
  }

  // ---------- Klaviyo waitlist subscribe ----------
  // 2026-10-05: 旧窓口 manage.kmail-lists.com（公式サポート外）から Klaviyo 正規の Create Client Subscription へ移行。
  // 流入元（UTM 等）は profile.properties、sourceLabel は custom_source で送る（snippets/si-signup.liquid）。
  // 202 以外は失敗＝下の .catch でエラー表示（以前は失敗しても成功表示になっていた）。
  function subscribeToList(listId, email, sourceLabel) {
    if (!window.siKlaviyoSubscribe) return Promise.reject(new Error('siKlaviyoSubscribe missing'));
    return window.siKlaviyoSubscribe(email, listId, sourceLabel);
  }

  function initWaitlistForms() {
    var forms = document.querySelectorAll('[data-v2-waitlist]');
    if (!forms.length) return;
    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailInput = form.querySelector('input[type="email"]');
        var feedback = form.querySelector('.v2-waitlist__feedback');
        var btn = form.querySelector('button[type="submit"]');
        var origLabel = btn ? btn.querySelector('.btn__label').textContent : '';
        var listId = form.dataset.listId || 'Wmbkbf';
        var newsletterId = form.dataset.newsletterId || 'TpkBLU';
        var sourceLabel = form.dataset.sourceLabel || 'Website';
        var optinEl = form.querySelector('[data-v2-newsletter-optin]');
        var wantsNewsletter = !!(optinEl && optinEl.checked);
        var email = (emailInput.value || '').trim();
        if (!email) {
          showFeedback(feedback, 'Email is required.', 'error');
          return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showFeedback(feedback, 'That doesn’t look like an email address.', 'error');
          return;
        }
        if (btn) {
          btn.querySelector('.btn__label').textContent = 'Sending…';
          btn.disabled = true;
        }
        var primary = subscribeToList(listId, email, sourceLabel);
        var chain = primary;
        if (wantsNewsletter && newsletterId && newsletterId !== listId) {
          chain = primary.then(function () {
            return subscribeToList(newsletterId, email, sourceLabel + ' (newsletter opt-in)');
          });
        }
        chain.then(function () {
          // Inline confirmation in form
          showFeedback(feedback, 'You’re on the list. A note is on its way.', 'success');
          if (btn) {
            btn.querySelector('.btn__label').textContent = 'You’re on the list';
            btn.disabled = true;
          }
          if (emailInput) emailInput.value = '';
          if (optinEl) optinEl.checked = false;
          // Close P1 if it was the source, then trigger P5 confirmation modal
          var p1 = document.querySelector('[data-v2-popup="p1"]');
          if (p1 && p1.hasAttribute('open')) {
            try { p1.close(); } catch (err) { p1.removeAttribute('open'); p1.style.display = 'none'; }
          }
          // Slight delay so P1's close transition completes
          setTimeout(showPopupP5, 320);
        }).catch(function () {
          showFeedback(feedback, 'Something went wrong. Please try again.', 'error');
          if (btn) {
            btn.querySelector('.btn__label').textContent = origLabel;
            btn.disabled = false;
          }
        });
      });
    });
  }

  function showFeedback(node, message, kind) {
    if (!node) return;
    node.textContent = message;
    node.style.marginTop = '12px';
    node.style.fontSize = '14px';
    node.style.color = kind === 'error' ? 'var(--shoito-error)' : 'var(--shoito-warm-black)';
    node.hidden = false;
  }

  // ---------- Reveal on scroll ----------
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal').forEach(function (n) { n.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.18 });
    document.querySelectorAll('.reveal').forEach(function (n) { io.observe(n); });
  }


  // ---------- Testimonials carousel (L improvement) ----------
  function initTestimonialsCarousel() {
    var roots = document.querySelectorAll('[data-v2-testimonials]');
    if (!roots.length) return;
    roots.forEach(function (root) {
      var track = root.querySelector('[data-v2-testimonials-track]');
      var dotsHost = root.querySelector('[data-v2-testimonials-dots]');
      if (!track || !dotsHost) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.v2-testimonials__card'));
      if (!cards.length) return;
      var perDesktop = parseInt(root.dataset.cardsPerPageDesktop, 10) || 3;
      var perMobile = parseInt(root.dataset.cardsPerPageMobile, 10) || 1;
      var autoplayMs = parseInt(root.dataset.autoplayMs, 10) || 6000;

      function cardsPerPage() {
        return window.matchMedia('(max-width: 900px)').matches ? perMobile : perDesktop;
      }
      function pageCount() {
        return Math.max(1, Math.ceil(cards.length / cardsPerPage()));
      }
      var pageIdx = 0;
      var timer = null;
      var hovering = false;

      function renderDots() {
        dotsHost.innerHTML = '';
        var n = pageCount();
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1) + ' of ' + n);
          if (i === pageIdx) b.classList.add('is-active');
          (function (idx) {
            b.addEventListener('click', function () {
              goToPage(idx);
              restartAutoplay();
            });
          })(i);
          dotsHost.appendChild(b);
        }
      }
      function activeDot() {
        var btns = dotsHost.querySelectorAll('button');
        btns.forEach(function (b, i) {
          b.classList.toggle('is-active', i === pageIdx);
        });
      }
      function goToPage(idx) {
        pageIdx = (idx + pageCount()) % pageCount();
        var first = cards[pageIdx * cardsPerPage()];
        if (!first) return;
        track.scrollTo({ left: first.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        activeDot();
      }
      function advance() {
        if (hovering) return;
        goToPage(pageIdx + 1);
      }
      function startAutoplay() {
        if (timer || pageCount() < 2) return;
        timer = setInterval(advance, autoplayMs);
      }
      function stopAutoplay() {
        if (timer) { clearInterval(timer); timer = null; }
      }
      function restartAutoplay() {
        stopAutoplay();
        startAutoplay();
      }

      root.addEventListener('mouseenter', function () { hovering = true; });
      root.addEventListener('mouseleave', function () { hovering = false; });
      // Pause when offscreen
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) startAutoplay(); else stopAutoplay();
          });
        }, { threshold: 0.25 });
        io.observe(root);
      } else {
        startAutoplay();
      }

      // Recompute pages on viewport change
      var mql = window.matchMedia('(max-width: 900px)');
      if (mql.addEventListener) mql.addEventListener('change', function () { pageIdx = 0; renderDots(); goToPage(0); });
      else if (mql.addListener) mql.addListener(function () { pageIdx = 0; renderDots(); goToPage(0); });

      // Update dot when user manually scrolls
      var scrollTimeout;
      track.addEventListener('scroll', function () {
        if (scrollTimeout) clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          var per = cardsPerPage();
          if (!cards.length || !cards[0]) return;
          var cardW = cards[0].getBoundingClientRect().width + 24;  // approx gap
          var newPage = Math.round(track.scrollLeft / (cardW * per));
          if (newPage !== pageIdx) {
            pageIdx = Math.max(0, Math.min(pageCount() - 1, newPage));
            activeDot();
          }
        }, 80);
      }, { passive: true });

      renderDots();
    });
  }

  // ---------- Init on DOM ready ----------
  function init() {
    initHeader();
    initMobileOverlay();
    initPopupP1();
    initWaitlistForms();
    initTestimonialsCarousel();
    initReveal();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
